import React from 'react';
import { Link } from 'react-router-dom';
import HomeIcon from '@mui/icons-material/Home';
import CorporateRegistrationForm from '../components/Auth/CorporateRegistrationForm';
import { Typography, Box } from '@mui/material';

function CorporateRegister() {
  return (
    <div className="register">
      <div className="register__container">
        <div className="register__logo">
          <HomeIcon style={{ fontSize: 50, color: '#1DA1F2' }} />
        </div>
        <Typography variant="h4" component="h1" gutterBottom>
          企業ユーザー登録
        </Typography>
        
        <Box sx={{ mb: 2 }}>
          <Typography variant="body1">
            企業ユーザーを新規登録するページです。基本情報と店舗情報を入力してください。
          </Typography>
        </Box>
        
        <CorporateRegistrationForm />
        
        <div className="register__footer">
          <p>
            既にアカウントをお持ちですか？{' '}
            <Link to="/login">ログインする</Link>
          </p>
        </div>
      </div>
    </div>
  );
}

export default CorporateRegister; 